// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body[data-theme=light]{background-color:#fff;color:#6359e9}`, "",{"version":3,"sources":["webpack://./features/theme-toggle/ui/themes/_light.sass"],"names":[],"mappings":"AAGA,uBACE,qBAJiB,CAKjB,aAJW","sourcesContent":["$background-color: #ffffff\n$text-color: #6359E9\n\nbody[data-theme='light']\n  background-color: $background-color\n  color: $text-color\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
